<template>
	<div id="app">
		<meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0,minimum-scale=1.0,user-scalable=0" />
		<router-view style="width: 100%;"></router-view>
	</div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
export default {
	name: 'app',
	methods: {
		...mapActions({
			getTheme: 'theme/getTheme'
		})
	},
	created() {
		this.getTheme({}).then();
	}
};
</script>

<style lang="scss">
#app {
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #2c3e50;
	overflow-x: scroll;
	overflow-y: auto;
	min-height: 100vh;
	font-size: 15px;
}
.el-container{
	background-color: #fff;
}
.flex {
	display: flex;
	flex-flow: row nowrap;
	justify-content: flex-start;
}
.space-between {
	justify-content: space-between;
}
.text-center {
	text-align: center;
}
.text-left {
	text-align: left;
}
.text-right {
	text-align: right;
}
.color-white {
	color: #ffffff;
}
.el-container:first-child {
	height: 100%;
}
.transition-box {
	margin-bottom: 10px;
	width: 200px;
	height: 100px;
	border-radius: 4px;
	background-color: #409eff;
	text-align: center;
	color: #fff;
	padding: 40px 20px;
	box-sizing: border-box;
	margin-right: 20px;
}
.el-row {
	margin-bottom: 20px;
	&:last-child {
		margin-bottom: 0;
	}
}
.el-col {
	border-radius: 4px;
}
.bg-purple-dark {
	background: #99a9bf;
}
.bg-purple {
	background: #d3dce6;
}
.bg-purple-light {
	background: #e5e9f2;
}
.grid-content {
	border-radius: 4px;
	min-height: 36px;
}
.row-bg {
	padding: 10px 0;
	background-color: #f9fafc;
}
.el-header,
.el-footer,
.el-aside {
	background-color: #141c23;
	color: #ffffff;
	line-height: 60px;
}
.el-menu-item.is-active {
	border-right: 3px solid #ffd04b;
}
.login {
	background: url(./assets/loginBackImg.jpg);
	background-size: auto 100%;
}
.el-form-item__label {
	color: #000000;
}

/* @media screen and (max-width:1300px) {
	aside{
		display: none !important;
	}
	.login{
		background: url(./assets/backimg.jpg);
		background-size: 100% 100%;
	}
}
@media screen and (min-width:1301px) {
	footer{
		display: none !important;
	}
	.login{
		background: url(./assets/backimg.jpg);
		background-size: 100% auto;
	}
} */
.el-dialog__body {
	overflow-y: scroll;
}
.color-green {
	color: green;
}
.color-red {
	color: #ff2f4b;
}
.el-dropdown {
	margin: 0 10px;
}
.edui-toolbar {
	line-height: 20px;
}
.el-divider {
	/* // background-color: #3cacf0; */
	.el-divider__text {
		color: #458efc;
		font-size: 16px;
	}
}
.color-blue {
	color: #409eff !important;
}
.upfile {
	position: relative;
	width: 150px;
	height: 150px;
	.delicon {
		position: absolute;
		width: 100%;
		height: 30px;
		left: 0;
		top: 0;
		background: rgba($color: #000000, $alpha: 0.3);
		.el-icon-delete {
			color: #fff;
			cursor: pointer;
			font-size: 20px;
			&:hover {
				color: red;
			}
		}
	}
}
.el-main{
	padding: 0 !important;
	>div{
		min-width: 1000px;
		width: calc(100vw - 240px);
		min-width: 1000px;
		max-width: 1200px;
		margin: 0 auto;
		min-height: calc(100vh - 65px);
	}
}
div{
	box-sizing: border-box;
}
.header {
	margin: 20px 0;
	.logo,
	.qrcode {
		width: 100px;
		height: 100px;
		cursor: pointer;
		img {
			width: 100%;
			height: 100%;
		}
	}
}
.goods {
	width: 100%;
	position: relative;
	.goods-item {
		height: 800px;
		position: relative;
		border: 1px solid #eee;
		margin-bottom: 30px;
		.goods-backimg {
			width: 100%;
			height: 400px;
			.el-image {
				width: 100%;
				height: 100%;
				&::after {
					content: '';
					position: absolute;
					left: 0;
					top: 0;
					width: 100%;
					height: 100%;
					background: -webkit-gradient(linear, left top, left bottom, color-stop(30%, rgba(255, 255, 255, 0.06)), to(#f8f8f8));
					background: -webkit-linear-gradient(rgba(255, 255, 255, 0.06) 30%, #f8f8f8);
					background: linear-gradient(rgba(255, 255, 255, 0.06) 30%, #f8f8f8);
				}
			}
		}
		.section {
			position: absolute;
			width: 90%;
			height: 530px;
			bottom: 0;
			left: 5%;
			background: rgba(255, 255, 255, 0.8);
			display: grid;
			grid-template-columns: repeat(auto-fill, 220px);
			grid-template-rows: 1fr 1fr;
			grid-gap: 15px;
			padding: 15px;
			overflow: hidden;
			cursor: pointer;
			.section-item {
				padding: 10px;
				background-color: #fff;
				text-align: left;
				box-shadow: 0 0 15px lightgray;
				.goods-pic {
					width: 180px;
					height: 180px;
					overflow: hidden;
					img {
						width: 100%;
						height: 100%;
						&:hover {
							transform: scale(1.3);
							transition: all 0.5s;
						}
					}
				}
				.goods-title {
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 1;
					font-size: 15px;
				}
				.goods-price {
					color: red;
				}
				.goods-sale{
					color: gray;
					font-size: 13px;
				}
			}
		}
	}
}
.guess {
	width: 100%;
	position: relative;
	.goods-item {
		position: relative;
		border: 1px solid #eee;
		margin-bottom: 30px;
		.section {
			position: relative;
			width: 94%;
			bottom: 0;
			margin-left: 4%;
			background: rgba(255, 255, 255, 0.8);
			display: grid;
			grid-template-columns: repeat(auto-fill, 220px);
			// grid-template-rows: 1fr 1fr;
			grid-template-rows: repeat(auto-fill, 1fr);
			grid-gap: 15px;
			padding: 15px;
			cursor: pointer;
			.section-item {
				padding: 10px;
				background-color: #fff;
				text-align: left;
				box-shadow: 0 0 15px lightgray;
				.goods-pic {
					width: 180px;
					height: 180px;
					overflow: hidden;
					img {
						width: 100%;
						height: 100%;
						&:hover {
							transform: scale(1.3);
							transition: all 0.5s;
						}
					}
				}
				.goods-title {
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 1;
					font-size: 15px;
				}
				.goods-price {
					color: red;
				}
				.goods-sale{
					color: gray;
					font-size: 13px;
				}
			}
		}
	}
}
.border{
	border:1px solid #eee;
}
li{
	list-style: none;
}
.background-clip{
	background-clip: content-box;
}
.coupon-list {
		background-color: #f3f3f3;
		display: flex;
		flex-flow: row wrap;
		padding: 10px;
	}
	/* 优惠券列表 */
	.coupon-item {
		width: 300px;
		display: flex;
		flex-direction: column;
		margin: 10px 12px;
		background: #fff;
		&:hover {
			cursor: pointer;
		}
		.con {
			display: flex;
			align-items: center;
			position: relative;
			height: 60px;
			padding: 0 15px;
			&:after {
				position: absolute;
				left: 0;
				bottom: 0;
				content: '';
				width: 100%;
				height: 0;
				border-bottom: 1px dashed #f3f3f3;
				transform: scaleY(50%);
			}
		}
		.left {
			display: flex;
			flex-direction: column;
			justify-content: center;
			flex: 1;
			overflow: hidden;
			height: 50px;
		}
		.title {
			font-size: 32upx;
			color: $font-color-dark;
			margin-bottom: 5px;
		}
		.time {
			font-size: 12px;
			color: $font-color-light;
		}
		.right {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			font-size: 13px;
			color: $font-color-base;
			height: 50px;
		}
		.price {
			font-size: 22px;
			color: $base-color;
			&:before {
				content: '￥';
				font-size: 17px;
			}
		}
		.tips {
			font-size: 12px;
			color: $font-color-light;
			line-height: 30px;
			padding: 0 15px;
		}
		.circle {
			position: absolute;
			left: -3px;
			bottom: -5px;
			z-index: 10;
			width: 10px;
			height: 10px;
			background: #f3f3f3;
			border-radius: 100px;
			&.r {
				left: auto;
				right: -3px;
			}
		}
		.coupon_checked {
			background: url(./assets/address_checked.png) no-repeat;
			background-position: right bottom;
			background-size: auto 100%;
		}
	}
	.left-menu{
		flex-shrink: 0;
	}
</style>

